"use strict";

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
define('model/attachment',['require','exports','module','./base','./upload','underscore'],function (require, exports, module) {
  var BaseModel = require('./base');
  var UploadModel = require('./upload');
  var _ = require('underscore');
  var SUBMISSION_TAB_ATTACHMENT_TYPE = 'submission';
  module.exports = BaseModel.extend({
    urlRoot: '/rs/api/attachment',
    idAttribute: 'docStoreId',
    childModels: {
      docStore: 'DocStore'
    },
    canDeleteAttachment: function canDeleteAttachment() {
      return this.get('attachmentType') === SUBMISSION_TAB_ATTACHMENT_TYPE;
    },
    getAttachmentDownloadUrl: function getAttachmentDownloadUrl() {
      if (this.get('stampedDocStore')) return '/rs/api/docstore/' + encodeURIComponent(this.get('stampedDocStore.id'));
      return '/rs/api/docstore/' + encodeURIComponent(this.id);
    },
    parse: function parse() {
      var data = BaseModel.prototype.parse.apply(this, arguments);
      if (_.isArray(data)) {
        return data[0];
      }
      return data;
    },
    update: function update() {
      return BaseModel.prototype.sync('update', this).then(function (response) {
        if (response.error) {
          this.trigger('error', this, response.error);
        } else {
          this.trigger('sync');
        }
      }.bind(this));
    }
  }, {
    SUBMISSION_ATTACHMENT_URL: '/rs/api/document/:documentId/attachment',
    ATTACHMENT_APPLY_STAMPS_URL: '/rs/api/attachment/stamp',
    createUploadCollection: function createUploadCollection(url, files) {
      return UploadModel.createCollection(url, files, this);
    },
    applyStamps: function applyStamps(decision, ids, collection) {
      var _decision$models;
      var expirationConfirmation = true;
      var latestDecision;
      if (decision && decision !== null && decision !== void 0 && decision.models && (decision === null || decision === void 0 || (_decision$models = decision.models) === null || _decision$models === void 0 ? void 0 : _decision$models.length) > 0) {
        var latestDate = null;
        var _iterator = _createForOfIteratorHelper(decision.models),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var model = _step.value;
            var finalizedDate = model.get('finalizedDate');
            if (finalizedDate && (!latestDate || finalizedDate > latestDate)) {
              latestDecision = model;
              latestDate = finalizedDate;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      if (latestDecision) {
        expirationConfirmation = latestDecision.isExpirationDateVisible();
      }
      var options = {
        url: this.ATTACHMENT_APPLY_STAMPS_URL,
        attrs: {
          "attachmentIds": ids,
          "expirationConfirmation": expirationConfirmation
        }
      };
      return BaseModel.prototype.sync('create', collection, options).then(function (resp) {
        _.each(resp.data, function (stampedAttachmentModel) {
          var match = collection.find({
            id: stampedAttachmentModel.docStoreId
          });
          if (match) match.set(stampedAttachmentModel);
        });
        collection.trigger('sync');
      });
    },
    buildUploadHandler: function buildUploadHandler(app, attachmentUrl, uploadParams, uploadCompleteHandler) {
      var uploadFiles = function (files) {
        var uploads = this.createUploadCollection(attachmentUrl, files).params(uploadParams).on('upload:complete', function () {
          uploadCompleteHandler();
        });
        app.request('file:upload', uploads);
      }.bind(this);
      return function () {
        app.request('file:chooser', {
          multiple: true,
          callback: uploadFiles
        });
      };
    }
  });
});

